export class StringUtils {
    public static isNullOrEmpty(val: string): boolean {
        if (val === undefined || val === null || val.trim() === '') {
            return true;
        }
        return false;
    }

    public static isCPF (document: string) {
      if (document.replace(/[^0-9]+/g, '').length != 11) {
        return false;
      }

      const docNumbers = document.match(/\d/g).map(Number);
      let docSum = docNumbers.reduce((acc, cur, idx) => {
        if (idx < 9) {
          return acc + cur * (10 - idx);
        }
        return acc;
      }, 0);

      var docRest = (docSum * 10) % 11;

      if (docRest === 10 || docRest === 11) {
        docRest = 0;
      }

      if (docRest !== docNumbers[9]) {
        return false;
      }

      docSum = docNumbers.reduce((acc, cur, idx) => {
        if (idx < 10) {
          return acc + cur * (11 - idx);
        }
        return acc;
      }, 0);

      docRest = (docSum * 10) % 11;

      if (docRest === 10 || docRest === 11) {
        docRest = 0;
      }

      if (docRest !== docNumbers[10]) {
        return false;
      }

      return true;
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/helpers/stringUtils.ts